import { useEffect, useState } from "react";
import { api } from "@/api/client";
import { WhatsappLogo, ChatTeardropDots, CheckCircle } from "@phosphor-icons/react";

export default function History() {
  const [items, setItems] = useState([]);
  const [inbound, setInbound] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState("sent"); // "sent" | "inbound"

  useEffect(() => {
    (async () => {
      const [s, i] = await Promise.all([api.get("/reminders/history"), api.get("/inbound/messages")]);
      setItems(s.data);
      setInbound(i.data);
      setLoading(false);
    })();
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#4A4A4A]">Activity log</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter mt-1">History</h1>
      </div>

      <div className="flex gap-2">
        <button data-testid="tab-sent" onClick={() => setTab("sent")} className={`nb-btn px-4 py-2 ${tab === "sent" ? "bg-[#4361EE] text-white" : "bg-white"}`}>
          Sent ({items.length})
        </button>
        <button data-testid="tab-inbound" onClick={() => setTab("inbound")} className={`nb-btn px-4 py-2 ${tab === "inbound" ? "bg-[#06D6A0]" : "bg-white"}`}>
          Inbound replies ({inbound.length})
        </button>
      </div>

      <div className="nb-card p-2">
        {loading ? (
          <p className="p-6 font-semibold">Loading…</p>
        ) : tab === "sent" ? (
          items.length === 0 ? (
            <p className="p-8 text-center font-semibold text-[#4A4A4A]">No reminders sent yet.</p>
          ) : (
            <ul className="divide-y-2 divide-black/10">
              {items.map((r) => (
                <li key={r.reminder_id} className="p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-2">
                  <div>
                    <div className="flex items-center gap-2">
                      <WhatsappLogo size={16} weight="bold" />
                      <p className="font-bold">{r.customer_name}</p>
                      <span className="text-xs font-mono text-[#4A4A4A]">{r.phone}</span>
                      {r.auto && <span className="text-[10px] font-black uppercase border-2 border-black bg-[#4ECDC4] rounded-full px-2 py-0.5">AUTO</span>}
                    </div>
                    <p className="text-xs text-[#4A4A4A] font-semibold mt-1 max-w-2xl">{r.message}</p>
                  </div>
                  <div className="flex items-center gap-2 flex-shrink-0">
                    {r.meta_code ? (
                      <span className="text-[10px] font-black uppercase border-2 border-black rounded-full px-2 py-0.5 bg-[#FF6B6B] text-white" title={r.meta_message || ""}>
                        FAILED · {r.meta_code}
                      </span>
                    ) : (
                      <span className={`text-[10px] font-black uppercase border-2 border-black rounded-full px-2 py-0.5 ${r.mocked ? "bg-[#FFD166]" : "bg-[#06D6A0]"}`}>
                        {r.mocked ? "MOCKED" : "SENT"}
                      </span>
                    )}
                    <span className="text-xs font-mono">{new Date(r.sent_at).toLocaleString()}</span>
                  </div>
                </li>
              ))}
            </ul>
          )
        ) : inbound.length === 0 ? (
          <p className="p-8 text-center font-semibold text-[#4A4A4A]">No customer replies yet.</p>
        ) : (
          <ul className="divide-y-2 divide-black/10">
            {inbound.map((m) => (
              <li key={m.inbound_id} className="p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-2">
                <div>
                  <div className="flex items-center gap-2">
                    <ChatTeardropDots size={16} weight="bold" />
                    <span className="text-xs font-mono">{m.from}</span>
                    {m.is_confirm && (
                      <span className="text-[10px] font-black uppercase border-2 border-black bg-[#06D6A0] rounded-full px-2 py-0.5 flex items-center gap-1">
                        <CheckCircle size={10} weight="bold" /> Auto-Serviced
                      </span>
                    )}
                  </div>
                  <p className="text-sm font-semibold mt-1">&ldquo;{m.body}&rdquo;</p>
                </div>
                <span className="text-xs font-mono">{new Date(m.received_at).toLocaleString()}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
      <p className="text-xs font-semibold text-[#4A4A4A]">
        Inbound webhook URL for Meta WhatsApp: <span className="font-mono bg-white border-2 border-black px-1 py-0.5 rounded">{process.env.REACT_APP_BACKEND_URL}/api/whatsapp/webhook</span>
        &nbsp;Configure this in Meta Developers → WhatsApp → Configuration → Callback URL (GET verifies, POST receives).
      </p>
    </div>
  );
}
